import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRenpyComponent } from './simple-icons-renpy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRenpyComponent ],
    exports:      [ SimpleIconsRenpyComponent ],
    bootstrap:    []
})
export class SimpleIconsRenpyModule {}
